import { useCallback, useEffect, useMemo, useState } from 'react';

/**
 * Returns true if the provided media query matches screen size.
 * Intended for use in responsive layout and changes in accordance with screen resize.
 */
export const useMediaQuery = (mediaQueryString: string) => {
  const mediaQuery = useMemo(
    () => globalThis.matchMedia(mediaQueryString),
    [mediaQueryString]
  );
  const [matches, setMatches] = useState<boolean>(mediaQuery.matches);

  const resizeEventHandler = useCallback((event: MediaQueryListEvent) => {
    setMatches(event.matches);
  }, []);

  useEffect(() => {
    mediaQuery.addEventListener('change', resizeEventHandler);

    return () => {
      mediaQuery.removeEventListener('change', resizeEventHandler);
    };
  }, [mediaQuery, resizeEventHandler]);

  return matches;
};
